import { hexToLinear, scaleColor } from '../../core/color';
import { createMeshBuilder } from '../mesh/meshBuilder';
import { rounded, box } from './lifeGeometry';
import type { LifeModel } from './models';

/** A small, unassigned working dog; coat and proportions are reconstruction choices. */
export function buildDogModel(): LifeModel {
  const b = createMeshBuilder(),
    forelegs = createMeshBuilder(),
    hindlegs = createMeshBuilder();
  const coat = hexToLinear('#796348'),
    dark = hexToLinear('#382f25');
  rounded(b, coat, [
    { y: 0.28, x: 0.1, depth: 0.24, half: 0.095 },
    { y: 0.36, x: -0.015, depth: 0.34, half: 0.13 },
    { y: 0.48, x: -0.015, depth: 0.36, half: 0.145 },
    { y: 0.55, x: -0.025, depth: 0.28, half: 0.095 },
  ]);
  rounded(
    b,
    scaleColor(coat, 0.82),
    [
      { y: 0.42, x: 0.24, depth: 0.12, half: 0.1 },
      { y: 0.63, x: 0.31, depth: 0.14, half: 0.105 },
      { y: 0.71, x: 0.3, depth: 0.09, half: 0.07 },
    ],
    6
  );
  rounded(
    b,
    coat,
    [
      { y: 0.49, x: 0.415, depth: 0.095, half: 0.05 },
      { y: 0.53, x: 0.43, depth: 0.11, half: 0.065 },
      { y: 0.59, x: 0.395, depth: 0.105, half: 0.07 },
      { y: 0.63, x: 0.34, depth: 0.065, half: 0.065 },
    ],
    6
  );
  box(b, dark, [0.51, 0.51, -0.047], [0.54, 0.565, 0.047]);
  for (const side of [-1, 1]) {
    box(b, dark, [0.389, 0.63, side * 0.074 - 0.012], [0.414, 0.647, side * 0.074 + 0.012]);
    rounded(
      b,
      dark,
      [
        { y: 0.535, x: 0.235, z: side * 0.112, depth: 0.025, half: 0.02 },
        { y: 0.62, x: 0.23, z: side * 0.13, depth: 0.055, half: 0.025 },
        { y: 0.68, x: 0.27, z: side * 0.09, depth: 0.045, half: 0.035 },
      ],
      4
    );
  }
  rounded(
    b,
    coat,
    [
      { y: 0.42, x: -0.32, depth: 0.055, half: 0.045 },
      { y: 0.5, x: -0.46, depth: 0.043, half: 0.032 },
      { y: 0.59, x: -0.55, depth: 0.025, half: 0.021 },
      { y: 0.66, x: -0.55, depth: 0.01, half: 0.01 },
    ],
    4
  );
  for (const [builder, hind] of [
    [forelegs, false],
    [hindlegs, true],
  ] as const) {
    rounded(
      builder,
      coat,
      [
        { y: -0.255, x: 0.015, depth: 0.022, half: 0.025 },
        { y: -0.19, x: hind ? -0.035 : 0.005, depth: 0.025, half: 0.03 },
        { y: -0.1, x: hind ? 0.035 : -0.015, depth: 0.04, half: 0.038 },
        { y: 0.025, x: 0, depth: hind ? 0.085 : 0.055, half: hind ? 0.07 : 0.047 },
      ],
      6
    );
    rounded(
      builder,
      scaleColor(coat, 0.72),
      [
        { y: -0.3, x: 0.02, depth: 0.055, half: 0.043 },
        { y: -0.28, x: 0.02, depth: 0.055, half: 0.043 },
        { y: -0.245, x: 0.01, depth: 0.035, half: 0.028 },
      ],
      6
    );
  }
  return {
    body: b.finish(),
    arm: forelegs.finish(),
    leg: hindlegs.finish(),
    shoulderY: 0.3,
    shoulderHalf: 0.12,
    hipY: 0.3,
    hipHalf: 0.12,
    foreX: 0.25,
    hindX: -0.26,
    hindPhase: 0.5,
    strideM: 0.46,
    stepLiftM: 0.045,
    sole: [-0.035, 0.075, -0.3],
  };
}
